import React from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { ButtonStatesInterface } from "./PropertyDocumentViewListItem";
import { ButtonStatusText } from "../../../../shadcn/components/custom/ButtonStatusText";
import { PDContactAuthorisedOfficerPopupCallSupportView } from "./PDContactAuthorisedOfficerPopupCallSupportView";
import { PDViewAuthorisedOfficerPopupModalProps } from "./PDViewAuthorisedOfficerPopupModal";

interface PDViewAuthorisedOfficerPopupActionButtonGroupPropsInterface {
  onRequestContactDetailsButtonClick: () => void;
  onWhatsAppButtonClick: () => void;
  showWhatsAppButton: boolean;
  requestCallbackButtonStates: ButtonStatesInterface;
  whatsAppButtonStates?: ButtonStatesInterface;
  setRequestCallbackVia: PDViewAuthorisedOfficerPopupModalProps["setRequestCallbackVia"];
}

export const PDViewAuthorisedOfficerPopupActionButtonGroup: React.FC<
  PDViewAuthorisedOfficerPopupActionButtonGroupPropsInterface
> = ({
  onRequestContactDetailsButtonClick = () => {},
  onWhatsAppButtonClick = () => {},
  showWhatsAppButton,
  requestCallbackButtonStates = {
    processing: false,
    error: false,
    success: false,
  },
  whatsAppButtonStates = { processing: false, error: false, success: false },
  setRequestCallbackVia = () => {},
}) => {
  return (
    <div className="flex flex-wrap gap-2 justify-center items-center">
      <div className="w-full md:w-auto">
        <Button
          onClick={() => {
            setRequestCallbackVia?.("Mobile");
            onRequestContactDetailsButtonClick?.();
          }}
          disabled={
            requestCallbackButtonStates?.processing ||
            requestCallbackButtonStates?.success
          }
          className={`w-full bg-white inline-flex md:hidden items-center gap-2 border border-[#f26c1f] text-brand-primaryAction px-4 py-2 rounded-full text-[0.85rem] font-medium hover:bg-[#f26c1f] hover:text-white transition-colors ${
            requestCallbackButtonStates?.success
              ? "bg-brand-primaryAction text-white"
              : ""
          }`}
        >
          <ButtonStatusText
            title="Request Call Back"
            successTitle="Requested Call Back"
            failureTitle="Failed to Request Call Back"
            processingTitle="Requesting Call Back"
            buttonStates={requestCallbackButtonStates}
          />
        </Button>

        <Button
          onClick={() => {
            setRequestCallbackVia?.("Desktop");
            onRequestContactDetailsButtonClick?.();
          }}
          disabled={
            requestCallbackButtonStates?.processing ||
            requestCallbackButtonStates?.success
          }
          className={`w-full bg-white md:inline-flex hidden items-center gap-2 border border-[#f26c1f] text-brand-primaryAction px-4 py-2 rounded-full text-[0.85rem] font-medium hover:bg-[#f26c1f] hover:text-white transition-colors ${
            requestCallbackButtonStates?.success
              ? "bg-brand-primaryAction text-white"
              : ""
          }`}
        >
          <ButtonStatusText
            title="Request Call Back"
            successTitle="Requested Call Back"
            failureTitle="Failed to Request Call Back"
            processingTitle="Requesting Call Back"
            buttonStates={requestCallbackButtonStates}
          />
        </Button>
        {requestCallbackButtonStates?.success && (
          <div className="text-[0.8rem] text-green-600">
            Our team will contact you shortly.
          </div>
        )}
      </div>

      {(showWhatsAppButton || whatsAppButtonStates?.success) && (
        <div className="w-full md:w-auto">
          <Button
            onClick={() => {
              onWhatsAppButtonClick?.();
            }}
            disabled={
              whatsAppButtonStates?.success || whatsAppButtonStates?.processing
            }
            className={`w-full bg-white inline-flex items-center gap-2 border border-[#f26c1f] text-brand-primaryAction px-4 py-2 rounded-full text-[0.85rem] font-medium hover:bg-[#f26c1f] hover:text-white transition-colors ${
              whatsAppButtonStates?.success
                ? "bg-brand-primaryAction text-white"
                : ""
            }`}
          >
            <ButtonStatusText
              title="Send to WhatsApp"
              successTitle="Sent to WhatsApp"
              failureTitle="Failed to Send to WhatsApp"
              processingTitle="Sending to WhatsApp"
              buttonStates={whatsAppButtonStates}
            />
          </Button>
          {whatsAppButtonStates?.success && (
            <div className="text-[0.8rem] text-green-600">
              Authorised Officer details sent to your WhatsApp.
            </div>
          )}
        </div>
      )}

      <PDContactAuthorisedOfficerPopupCallSupportView />
    </div>
  );
};
